import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getRequestVersion = (state: ContentPluginRootState) => state.data.requestVersion;

export default getRequestVersion;
